//editar_cita
import React, { useContext, useEffect, useState } from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'
import {IoMdArrowDropdown} from 'react-icons/io'
import {IoChevronBackOutline} from  'react-icons/io5'
import {BiCheck} from  'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import ApiCalendar from "react-google-calendar-api";
import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
const config = {
    clientId: "120251394725-odcgh221pgbild6n02k22a7qjsnls72i.apps.googleusercontent.com",
    apiKey: "AIzaSyDmACRaWHwMi8m8t3ivDh83o49N7XJS-aM",
    scope: "https://www.googleapis.com/auth/calendar",
    discoveryDocs: [
      "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
  };
  const apiCalendar = new ApiCalendar(config);

export default function EditarCitaClient({...props}) {

console.log(props);

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const {user} = useContext(AuthContext)
    const {notify} = useContext(AlertContext)
    const [state, setState] = useState({
        step:0,
        selected_date:null,
        specialists:[],
        specialists_pisco:[],
        specialists_couch:[],
        selected_speciality:null,
        selected_specialist:null,
        selected_day:date,
        selected_time:'',
        selected_daytime:null,
        description:'',
        loading:false

    })
    useEffect(()=>{
        
       
        const run = async () => {
           const psico = await Service('GET', 'Appointment/specialist/1')

           const couch = await Service('GET', 'Appointment/specialist/2')

           setState({...state, specialists_pisco:psico.data, specialists_couch:couch.data.filter((couch) => couch.id !=="39951cfb-db8e-458a-bd45-1e008e1a92bd" && couch.id !=="4346535a-79ea-4756-994e-d14d937093df" && couch.id !=="aa534137-f287-48b2-866a-f2816973f335"), specialists:[...couch.data.filter((couch) => couch.id !=="39951cfb-db8e-458a-bd45-1e008e1a92bd" && couch.id !=="4346535a-79ea-4756-994e-d14d937093df" && couch.id !=="aa534137-f287-48b2-866a-f2816973f335")]})

        }
        run()

        return () => {}
        
    },[])

    const _schedule = async () => {

   
        setState({...state, loading:true})


        try {
            const start = new Date(state.selected_daytime);
            const end = new Date(state.selected_daytime.setHours(state.selected_daytime.getHours() + 1));

    
    
            const res = await apiCalendar.handleAuthClick();
            if(res.access_token !== undefined){
                const eventWithVideoConference = {
                    summary: "Cita Bien Vivir",
                    start: {
                      dateTime: start,
                      timeZone: "America/Mexico_City",
                    },
                    end: {
                      dateTime: end,
                      timeZone: "America/Mexico_City",
                    },
                  };
                  
                  apiCalendar
                    .createEventWithVideoConference(eventWithVideoConference)
                    .then(async (result) => {
                        console.log(result);

                        let body = {
                            userId: user.id,
                            specialistId: state.selected_specialist.id,
                            date: start,
                            description: "Cita Bien Vivir",
                            sessionUrl:result.result.hangoutLink
                        }
                        console.log(body);
                        const schedule = await Service('POST', 'Appointment', body);

                        if(schedule?.status === 200){
                            notify({title:'Listo!', message:'Se ha agendado un nueva cita.', type:'success'})

                            let callback = {
                                date: start,
                                sessionUrl:result.result.hangoutLink,
                                numberOfSession:0,
                                specialist:state.selected_specialist,  
                            }
                            props.onSchedule(callback)
                            
                            props.onCancel()
                        }else{
                            notify({title:'Error!', message:'No se puede agendar una cita en este momento.', type:'error'})
                            props.onCancel()
                        }
                       
                       
        
    
                        console.log(schedule)
                    })
                    .catch((error) => {
                      console.log(error);
                      notify({title:'Error!', message:'Al conectar con Google Calendar.', type:'error'})
                      props.onCancel()
                    });
            }
            
        } catch (error) {
            console.log(error)
            notify({title:'Error!', message:'Al conectar con Google Calendar.', type:'error'})
        }

       
    }
    Number.prototype.pad = function(size) {
        var s = String(this);
        while (s.length < (size || 2)) {s = "0" + s;}
        return s;
    }
    const onReSchedule = async () => {
        let start = new Date(state.selected_daytime);

        var day = start.getDate();
        var month = start.getMonth() + 1; //months are zero based
        var year = start.getFullYear();
        const time = start.toLocaleTimeString('es-ES').replace(/(.*)\D\d+/, '$1');
        let date_parsed = year + '-' + month.pad() + '-' + day.pad() + 'T' + time + ':00.000Z';
      
        let body = {
            userId: user.id,
            specialistId: props.cita.specialist.id,
            date: date_parsed,
            description: props.cita.description,
            sessionUrl: props.cita.sessionUrl
        }
        console.log(body);
        let _schedule = await Service('PUT', `Appointment/${props.cita.id}`, body)
        if(_schedule?.status === 200){
            notify({title:'Listo!', message:'Se ha reagendado tu cita.', type:'success'})

            let callback = {
                ...props.cita,
               
            }
            callback.date = start
       
         
            props.onSchedule(callback)
            props.onCancel()
        }else{
            notify({title:'Error!', message:'No ha sido posible re agendar en este momento.', type:'error'})
            props.onCancel()
        }
    }



    const onChangeSpecialist = async () => {
        let start = new Date(props.cita.dateOfEvent);
        console.log(start)
   
        let body = {
            userId: user.id,
            specialistId: state.selected_specialist.id,
            date:start,
            description: props.cita.description,
            sessionUrl: props.cita.sessionUrl
        }
        console.log(body);
        let _schedule = await Service('PUT', `Appointment/${props.cita.id}`, body)
        if(_schedule?.status === 200){
            notify({title:'Listo!', message:'Tu cita ha sido actulizada.', type:'success'})

            let callback = {
                ...props.cita,
               
            }
            callback.specialist = state.selected_specialist
       
         
            props.onSchedule(callback)
            props.onCancel()
        }else{
            notify({title:'Error!', message:'No ha sido posible actulizar tu cita.', type:'error'})
            props.onCancel()
        }
    }

    const onCancelCita = async () => {


      
        let _delete = await Service('DELETE', `Appointment/${props.cita.id}`)
        if(_delete?.status === 200){
            notify({title:'Listo!', message:'Tu cita ha sido cancelada.', type:'success'})

            let callback = {
                ...props.cita,
               
            }

            props.onDelete(callback);
            props.onCancel()
        }else{
            notify({title:'Error!', message:'No ha sido posible cancelar tu cita.', type:'error'})
            props.onCancel()
        }

    }

 
    var arr = [
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
    ]

    var weekday=new Array(7);
    weekday[0]="Domingo";
    weekday[1]="Lunes";
    weekday[2]="Tuesday";
    weekday[3]="Miercoles";
    weekday[4]="Jueves";
    weekday[5]="Viernes";
    weekday[6]="Sabado";

    var months=new Array(7);
    months[0]="Enero";
    months[1]="Febrero";
    months[2]="Marzo";
    months[3]="Abril";
    months[4]="Mayo";
    months[5]="Junio";
    months[6]="Julio";
    months[7]="Agosto";
    months[8]="Septiembre";
    months[9]="Octubre";
    months[10]="Noviembre";
    months[11]="Diciembre";

    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;   
    }


  return (
    <>
     <Renderif isTrue={state.loading === true}>
      <Loader></Loader>
    </Renderif>
    <div className='overlay d-flex justify-content-center align-items-center'>
        <Renderif isTrue={state.step === 0}>
            <div className='bv-modal shadow'>

                <div className='px-4 pt-3 pb-4 d-flex flex-column align-items-center'>
                    <div className='f-18 text-gray bold'>Proxima Cita</div>

                    <div className='f-14 text-gray mt-4'>Su próxima cita sera el día: </div>
                    <div className='text-gray f-18'>{weekday[new Date(props.cita.dateOfEvent).getDay()]} {new Date(props.cita.dateOfEvent).getDate()} {months[new Date(props.cita.dateOfEvent).getMonth()]} {new Date(props.cita.dateOfEvent).getFullYear()}</div>



                    <div className='text-gray text-center f-16 mt-2'>{new Date(props.cita.dateOfEvent).getHours()}:{new Date(props.cita.dateOfEvent).getMinutes()} hrs.</div>

                    <div className='mt-3 d-flex flex-column align-items-center'>
                        <div className='avatar avatar--big'></div>
                        <div className='f-16 bold'>{props.cita.specialist.firstName} {props.cita.specialist.lastName}</div>
                        <div className='f-16'>{props.cita.specialist.email}</div>
                    </div>

              
                </div>
                <div className='d-flex b-top p-4'>
                    <div className='col'></div>
                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={()=>{
                         props.onCancel()
                    }}>Cerrar</div>
                    <div className='bv-pill bv-pill--red me-2 cursor-pointer px-4' onClick={()=>{

                        setState({...state, step:2})

                    }}>Cancelar Cita</div>
                    <div className='bv-pill bv-pill--primary cursor-pointer px-4' onClick={()=>{
                   
                        setState({...state, step:1})
                      
                    }}>Editar</div>
                </div>

            </div>
        </Renderif>
        <Renderif isTrue={state.step === 1}>
            <div className='bv-modal shadow'>

                <div className='px-4 pt-3 pb-4 d-flex flex-column align-items-center'>
                    <div className='f-18 text-gray bold'>Selecciona una opcion a continuación</div>

                    <div className='f-14 text-gray mt-4'>¿Deseas reagendarla o cambiar de coach?</div>
                
                </div>
                <div className='d-flex b-top p-4'>
                    <div className='col'></div>

                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer px-4' onClick={()=>{

                         props.onCancel()

                    }}>Cancelar</div>

                    <div className='bv-pill bv-pill--secondary  me-2  cursor-pointer px-3' onClick={()=>{
                   
                        setState({...state, step:3})
                      
                    }}>Reagendar</div>
                    <div className='bv-pill bv-pill--primary cursor-pointer px-3' onClick={()=>{
                   
                        setState({...state, step:4})
                 
                     }}>Cambiar Coach</div>
                
                <div className='col'></div>
                </div>

            </div>
        </Renderif>
        <Renderif isTrue={state.step === 2}>
            <div className='bv-modal shadow'>

                <div className='px-4 pt-3 pb-4 d-flex flex-column align-items-center'>
                    <div className='f-18 text-gray bold'> ¿Cancelar Cita? </div>

                    <div className='f-14 text-gray mt-4'>¿Estás seguro de que deseas cancelar tu cita para el</div>
                    <div className='text-gray f-18 mt-3'>{weekday[new Date(props.cita.dateOfEvent).getDay()]} {new Date(props.cita.dateOfEvent).getDate()} {months[new Date(props.cita.dateOfEvent).getMonth()]} {new Date(props.cita.date).getFullYear()}</div>

                    <div className='text-gray text-center f-18'>a las {new Date(props.cita.dateOfEvent).getHours()}:00 hrs.</div>
                
                </div>
                <div className='d-flex b-top p-4'>
                    <div className='col'></div>

                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer px-4' onClick={()=>{

                         props.onCancel()

                    }}>Salir</div>

                    <div className='bv-pill bv-pill--red me-2 cursor-pointer px-4' onClick={()=>{

                        onCancelCita()

                    }}>Cancelar Cita</div>

            
                
                <div className='col'></div>
                </div>

            </div>
        </Renderif>
        <Renderif isTrue={state.step === 3}>
            <div className='bv-modal shadow'>

                <div className='px-4 pt-3 pb-4 d-flex flex-column align-items-center'>

                    <div className='d-flex align-items-center w-100'>
                    
                        <div className='col'></div>
                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={()=>{
                            props.onCancel()
                        }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                    </div>

                    <div className='f-18 text-gray bold'>Reagendar Cita</div>

                  
                    
                 

                <div className='d-flex overflow-hidden py-2 px-4'>

                    <div className='col'>
                    <BVCalendar init={date} onChange={(evt)=>{
                        // console.log(evt)
                        // if(evt < new Date()){
                        //     console.log("NEL")
                        //     return;
                        // }
                        setState({...state, selected_day:evt})
                    }}></BVCalendar>
                    </div>

                    <div className='col overflow-auto hide-scroll ps-3 d-none'>

                    

                       {
                            arr.map((item,i)=>{
                                return(
                                    <div key={i} className={`d-flex align-items-center py-2 b-bottom ps-1 ${state.selected_time === i ? 'highlight-active':''}`}>
                                        <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                        <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                        <div className='col f-12 text-gray'>{item}</div>
                                        <div className={`bv-pill cursor-pointer ${state.selected_time === i ? 'bv-pill--primary':'bv-pill--gray'}`} onClick={()=>{

                                        

                                            let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                            console.log(daytime)
                                            
                                            setState({...state, selected_time:i, selected_daytime:daytime})
                                        }}>Seleccionar</div>
                                    </div>
                                )
                            })
                       }
             
                        
                    </div>
                    <div className='col overflow-auto hide-scroll ps-3'>

                        <Renderif isTrue={state.selected_day < new Date()}>
                            <div className='f-14 bold text-gray'>En BienVivir, programar citas solo es posible a partir del día siguiente.</div>
                        </Renderif> 

                        <Renderif isTrue={state.selected_day > new Date()}>
                        {
                            arr.map((item,i)=>{
                                return(
                                    <div key={i} className={`d-flex align-items-center justify-content-center py-2 b-bottom ps-1 highlight-hover ${state.selected_time === i ? 'highlight-active':''}`} onClick={()=>{
                                        let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                            console.log(daytime)
                                            
                                            setState({...state, selected_time:i, selected_daytime:daytime})
                                    }}>
                                        <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                        <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                        <div className='col f-12 text-gray'>{item}</div>
                                        <div className='bv-icon bv-icon--mid me-2'>
                                            <BiCheck size={28} color={`${state.selected_time===i ? '#0972CE':'transparent'}`}></BiCheck>
                                        </div>
                                        {/* <div className={`bv-pill cursor-pointer ${i === 0 ? 'bv-pill--primary':'bv-pill--gray'}`}>Seleccionar</div> */}
                                    </div>
                                )
                            })
                        }
                        </Renderif>

                    
                    </div>
                </div>


              
              
                </div>
                <div className='d-flex b-top p-4'>
                    <div className='col'></div>
                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={()=>{
                         props.onCancel()
                    }}>Cancelar</div>
                    <div className='bv-pill bv-pill--primary cursor-pointer px-4' onClick={()=>{
                   
                      
                        onReSchedule()
                      
                    }}>Reagendar Cita</div>
                </div>

            </div>
        </Renderif>

        <Renderif isTrue={state.step === 4}>
            <div className='bv-modal shadow'>

                <div className='px-4 pt-3 pb-4 d-flex flex-column align-items-center'>
                    <div className='f-18 text-gray bold'>Cambiar Especialista</div>

                    {/* <div className='f-14 text-gray mt-4'>Su próxima cita sera el día: </div>
                    <div className='text-gray f-18'>{weekday[new Date(props.cita.date).getDay()]} {new Date(props.cita.date).getDate()} {months[new Date(props.cita.date).getMonth()]} {new Date(props.cita.date).getFullYear()}</div>
 */}


                    

                    <div className='mt-3 d-flex flex-column align-items-center'>
                        <div className='avatar avatar--big'></div>
                        <div className='f-16 bold'>{props.cita.specialist.firstName} {props.cita.specialist.lastName}</div>
                        <div className='f-16'>{props.cita.specialist.email}</div>
                    </div>

                    <div className='mt-3'>
                        <DropDown 
                            title='Seleccione el Profesional'
                            open={false}
                            // defaultValue={0} 
                            _onChange={(evt)=>{
                            console.log(evt)
                            setState({...state, selected_specialist:evt.value})
                        }}>

                            {
                                state.specialists.map((item, i)=>{
                                    return (
                                        <DropDownOption key={i} value={item} label={`${item.firstName} ${item.lastName}`}>
                                            <div className='f-14 text-gray'>{item.firstName} {item.lastName}</div>
                                        </DropDownOption>
                                    )
                                })
                            }
                           
                         
                        
                            
                        </DropDown>
                    </div>

              
                </div>
                <div className='d-flex b-top p-4'>
                    <div className='col'></div>
                    <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={()=>{
                         props.onCancel()
                    }}>Cerrar</div>
             
                    <div className='bv-pill bv-pill--primary cursor-pointer px-4' onClick={()=>{
                   
                   onChangeSpecialist()
                      
                    }}>Guardar</div>
                </div>

            </div>
        </Renderif>
 
    </div>
    </>
  )
}
